import React from 'react';
import QuarterlyLearningDays from '@/components/admin/QuarterlyLearningDays';

export default function QuarterlyLearningDaysPage() {
  return <QuarterlyLearningDays />;
}